<template>
  <div v-if="actionConfigs" class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view :action="actionConfigs"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'Action',
  components: { ContentTabBar },
  computed: {
    ...mapState('primary', ['actionConfigs']),
    ...mapState('route', ['name']),
    tabs() {
      return [
        {
          label: 'Summary',
          link: {
            name: 'actions.index.detail',
            params: { id: this.actionConfigs.id },
          },
          icon: 'action',
        },
        {
          label: 'Edit',
          link: {
            name: 'actions.index.detail.edit',
            params: { id: this.actionConfigs.id },
          },
          icon: 'edit',
        },
        {
          label: 'Delete',
          link: {
            name: 'actions.index.detail.delete',
            params: { id: this.actionConfigs.id },
          },
          icon: 'delete',
        },
      ];
    },
  },
  async beforeMount() {
    await this.$store.dispatch('primary/getActionConfigs', {
      id: this.$route.params.id,
    });
  },
};
</script>
